import React from 'react';
import {useAppModel, useProductSearch} from '../../contexts';
import styles from './model-filter.module.scss';

type ModelFilterProps = {
  onClick?: () => void;
};

export const ModelFilter: React.FunctionComponent<ModelFilterProps> = ({
  onClick,
}) => {
  const {appModel} = useAppModel();
  const {facets, toggleFilterOption} = useProductSearch();

  const modelFacet = facets.find((facet) => facet.id === `model`);

  if (!modelFacet || !appModel) {
    return null;
  }

  const allFilterActive =
    modelFacet.options.filter((option) => option.selected).length !== 1;

  const clearModelFilter = () => {
    modelFacet.options.forEach((option) => {
      if (!option.selected) return;
      toggleFilterOption({
        facetId: option.facetId,
        id: option.id,
        selected: false,
      });
    });
    if (onClick) onClick();
  };

  return (
    <div role="tablist" className={styles.modelTab}>
      <button
        className={`${styles.tabButton} ${
          allFilterActive ? styles.active : ``
        }`}
        onClick={clearModelFilter}
      >
        {appModel?.modelTabAllModels}
      </button>
      {modelFacet.options.map((option) => {
        const isActive = option.selected && !allFilterActive;

        const onOptionClick = () => {
          if (isActive) return;
          clearModelFilter();
          toggleFilterOption({
            facetId: option.facetId,
            id: option.id,
            selected: true,
          });
          if (onClick) onClick();
        };

        return (
          <button
            key={option.id}
            id={`${option.id}-control`}
            aria-controls={`${option.id}-panel`}
            aria-selected={isActive}
            disabled={option.disabled}
            className={`${styles.tabButton} ${isActive ? styles.active : ``}`}
            role="tab"
            onClick={onOptionClick}
          >
            {option.displayName}
          </button>
        );
      })}
    </div>
  );
};
